module.exports = __webpack_public_path__ + "5cef0b09ffa788e828b00d403bec752d.png";